<template>
    <div class="wrapper-bg">
        <HeaderOther
            :setTitle="'ประวัติการใช้แต้ม'"
            :setHref="'profile'"
            :showLogo="true"
        />
        <div class="main-layout coffee-nofooter">
            <SelectHistory />
            <FilterDate @afterFilter="afterFilter($event)" />

            <div class="container-history-earn-point">
                <div class="wrapper-table-history-point">
                    <div class="pd-table-history-point">
                        <div v-if="isFiltered">
                            <BurnList
                                :lbl="lbl"
                                :listConfig="purchaseListConfig"
                                :filterConfig="purchaseFilterListConfig"
                                :busEvent="busHistory"
                                :isLoading="isLoading"
                                @toggleLoading="toggleLoading($event)"
                            />
                        </div>
                        <div v-else class="text-center pt-2">
                            ไม่พบประวัติการใช้คะแนน
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// library
import Vue from "vue";
import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
// helper
import Locale from "@/helper/locale/locale.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//components
import HeaderOther from "@/components/Header/HeaderOther.vue";
import SelectHistory from "@/components/Userpoint/SelectHistory.vue";
import FilterDate from "../component/FilterDates.vue";
// core
import BurnList from "../component/BurnList.vue";
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
    PointListConfigBuilder,
} from "@/core/History/model/HistoryConfigModel.js";

export default {
    name: "History",
    mixins: [AccountMixin],
    components: {
        BurnList,
        HeaderOther,
        SelectHistory,
        FilterDate,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            isLoading: false,
            purchaseListConfig: {},
            purchaseFilterListConfig: {},
            pointListConfig: {},
            busHistory: new Vue(),

            isFiltered: false,
            currentFilterDate: {},
        };
    },
    created: function () {
        this.initialIsFromLanding();
    },
    methods: {
        initialBurn: function (date) {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .setStartDate(date.startDate)
                .setEndDate(date.endDate)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder().create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        initialEarnPoint: function () {
            //initial config for api.
            var listConfig = new PointListConfigBuilder().setDate("").create();
            this.pointListConfig = listConfig;
        },
        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(
                cacheHelper.getCache("isfromlanding")
            );

            if (formLanding != null) {
                cacheHelper.removeCache("isfromlanding");
            }
        },
        //#endregion initial
        initialExpiringPoint: function () {},

        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        afterFilter: function (date) {
            this.isFiltered = false;
            this.initialBurn(date);
            this.$nextTick(() => {
                this.isFiltered = true;
            });
        },
    },
};
</script>

<style lang="scss">
@import "@/module/History/page/SelectHistory.scss";
</style>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
@import "@/module/History/page/TableHistory.scss";
.wrapper-bg {
    padding-bottom: 0;
    .container-history-earn-point {
        overflow: auto;
        margin-top: 15px;
    }
}
</style>
